<!-- ********************WEB VIEW******************** -->



<!-- Premiere Card web-view -->
<div class="divLineup" style="background-color: white;">


    <span>
        <img class="image" src="{{premiere.mobilethumbimage}}" />
    </span>


    <h3 class="spotlightsDate">
        {{premiere.cinejoySpotlightsSchedule[0].scheduleTimeText | date:'EEE, MMMM d, y, h:mm:ss a'}} {{timezone}}
    </h3>


    <h3 class="spotLightsTitle">{{premiere.name}}</h3>

    <a *ngIf="!archive" class="spotLightsTitle" style="font-size: 14px;" [href]="groupshareUrl" target="_blank">Experience Spotlight with Group</a>
    <div class="spotlight_button" fxLayoutGap="10px" *ngIf="!archive">
        <button id="btn1" (click)="open(premiere.eventId, premiere, 'Buy')" *ngIf="!isBuyButtonActive">Buy</button>
        <button id="btn2" (click)="redirect()" [disabled]="joinButtonDisabled"> Join</button>
        <button id="btn3" (click)="gotoMoreInfo(premiere.eventId,premierename)">More Info</button>
        <button id="btn4" (click)="openDialog(premiere)" style="margin-top: 5px;" *ngIf="isBuyButtonActive && joinButtonDisabled">
           <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
           <ng-container *ngIf="exsistingGroup">Manage Group</ng-container>
        </button>
    </div>

    <div class="spotlight_button" style="text-align: center !important; margin-left: 0 !important;" fxLayoutGap="10px" *ngIf="archive">
        <button id="btn3" (click)="gotoMoreInfo(premiere.eventId,premierename)">More Info</button>
    </div>

</div>


<!-- Premiere Card web-view Ended -->

<!-- ********************WEB VIEW ENDED******************** -->
